module.exports = __webpack_public_path__ + "img/search.f55d30cd.svg";